export class Logger {
  private debug: boolean;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  log(message: string, ...args: any[]) {
    if (this.debug) {
      console.log(`[LegacyChain SDK] ${message}`, ...args);
    }
  }

  error(message: string, error?: any) {
    console.error(`[LegacyChain SDK] ${message}`, error);
  }

  warn(message: string, ...args: any[]) {
    if (this.debug) {
      console.warn(`[LegacyChain SDK] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (this.debug) {
      console.info(`[LegacyChain SDK] ${message}`, ...args);
    }
  }
} 